<template>
  <div class="welcome-font">
    欢迎使用数据采集平台
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    mounted() {
    },
    methods: {}
  };
</script>

<style scoped lang="scss">
  .welcome-font {
    text-align: center;
    font-size: 20px;
    padding-top: 50px;
    color: #f05259;
  }
</style>
